<div class="fx-admin-kyc">
  <div class="row">
    <div class="col">
      <fx-tab
        [tabs]="tabs"
        [activeTab]="tabSelect"
        (selected)="onChangeTab($event)">
      </fx-tab>
    </div>
  </div>
  <fx-kyc-list *ngIf="tabSelect == tabs[0]"
    [permission]="permission">
  </fx-kyc-list>

  <fx-credit-card *ngIf="tabSelect == tabs[1]"
    [permission]="permission">
  </fx-credit-card>
</div>
